// Copyright 2026 - Hewlett Packard Enterprise Company

// Authorization slugs as delivered by GET /ui-doorway/compute/v1/user-permissions.
export const PERMISSION_SLUGS = {
  APPLIANCE_EDIT: 'compute.oneview-appliance.edit',
  APPLIANCE_CREATE: 'compute.oneview-appliance.create',
  SERVER_EDIT: 'compute.server.edit',
  APPROVAL_POLICY_CREATE: 'compute.approval.policy.create',
  APPROVAL_POLICY_DELETE: 'compute.approval.policy.delete',
  APPROVAL_POLICY_EDIT: 'compute.approval.policy.edit',
  APPROVAL_REQUEST_APPROVE: 'compute.approval.request.approve',
  AUTHENTICATION_MANAGE: 'application.authentication.manage',
} as const;

export type PermissionSlug =
  (typeof PERMISSION_SLUGS)[keyof typeof PERMISSION_SLUGS];

// A slug the caller has not been told about is absent rather than false.
export type UserPermissions = Partial<Record<PermissionSlug, boolean>>;
